import React, { FunctionComponent } from 'react';
import DatePicker from 'react-datepicker';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback1 } from '../../common/models/callback';

interface IProps {
  from: Date;
  to: Date;
  onChangeFrom: IBindingCallback1<Date>;
  onChangeTo: IBindingCallback1<Date>;
}

const DateRange: FunctionComponent<IProps> = ({ from, to, onChangeFrom, onChangeTo }) => (
  <div className="d-flex flex-column">
    <FormattedMessage id="dateRange.from" defaultMessage="from">
      {placeholder => (
        <DatePicker
          selected={from}
          onChange={onChangeFrom}
          selectsStart
          startDate={from}
          endDate={to}
          maxDate={to}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          placeholderText={placeholder?.toString()}
        />
      )}
    </FormattedMessage>
    <FormattedMessage id="dateRange.to" defaultMessage="to">
      {placeholder => (
        <DatePicker
          selected={to}
          onChange={onChangeTo}
          selectsEnd
          startDate={from}
          endDate={to}
          minDate={from}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          placeholderText={placeholder?.toString()}
        />
      )}
    </FormattedMessage>
  </div>
);

export default DateRange;
